"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactQuery = require("react-query");
var _core = require("@folio/stripes/core");
var _utils = require("../../utils");
const useSettingSection = _ref => {
  let {
    sectionName,
    settingEndpoint,
    getQueryNamespaceGenerator = _ref2 => {
      let {
        queryParams
      } = _ref2;
      return ['stripes-kint-components', 'useSetting', 'appSettings', queryParams, sectionName];
    },
    getMutateNamespaceGenerator = () => ['stripes-kint-components', 'useSetting', 'putSetting', sectionName]
  } = _ref;
  const ky = (0, _core.useOkapiKy)();
  const queryParams = (0, _utils.generateKiwtQueryParams)({
    filters: [{
      path: 'section',
      value: sectionName
    }],
    sort: [{
      path: 'key'
    }],
    perPage: 100,
    stats: false
  }, {});
  const {
    data: settings = [],
    ...settingsQuery
  } = (0, _reactQuery.useQuery)(getQueryNamespaceGenerator({
    queryParams
  }), () => ky(`${settingEndpoint}?${queryParams?.join('&')}`).json());
  const {
    mutateAsync: putSetting,
    ...settingsMutate
  } = (0, _reactQuery.useMutation)(getMutateNamespaceGenerator(), data => ky.put(`${settingEndpoint}${data.id ? '/' + data.id : ''}`, {
    json: data
  }));
  return {
    handleSubmit: putSetting,
    settings,
    settingsQuery,
    settingsMutate
  };
};
var _default = exports.default = useSettingSection;